import { TableHeaderType } from '../enums';
import { AdditionalTableHeader, HoldingDescriptionTableHeader, HoldingIdentifierTableHeader, ScrollableHoldingsTableConfig } from '../interfaces';


// `default` columns for PAC and PC
export const LeftTableHeaders: { [type: string]: [HoldingIdentifierTableHeader, HoldingDescriptionTableHeader, ...Array<AdditionalTableHeader>] } = {
	'default': [
		{
			type: TableHeaderType.ID,
			label: 'ISIN',
			widthPct: 20
		},
		{
			type: TableHeaderType.Description,
			label: 'Name',
			widthPct: 80,
			dataIndex: 1
		}
	]
};

export const ScrollableHoldingsTableBreakPointME: number = 11;

export const DefaultScrollableHoldingsTableConfig: { [type: string]: ScrollableHoldingsTableConfig } = {
	HOLDINGS_TABLE: {
		dataTabId: 'holdings.table',
		header: {
			usePortfolioNameHeaders: true,
			leftTableHeaderConfigs: LeftTableHeaders.default
		},
		options: {
			showPercentageSymbol: true,
			decimalPipeDigitsInfo: '1.2-2',
			rightColClass: 'col-6',
			leftColClass: 'col-18',
			componentBreakpoint: 4,
			replaceZeroWithDash: true
		}
	},
	LATEST_HOLDINGS_TABLE: {
		dataTabId: 'latestHoldings',
		options: {
			showPercentageSymbol: false,
			decimalPipeDigitsInfo: '1.1-1',
			rightColClass: 'col-6',
			leftColClass: 'col-18',
			componentBreakpoint: ScrollableHoldingsTableBreakPointME,
			replaceZeroWithDash: true
		}
	},
	CHANGES_TO_HOLDINGS_TABLE: {
		dataTabId: 'changesToHoldings',
		options: {
			showPercentageSymbol: false,
			decimalPipeDigitsInfo: '1.1-1',
			rightColClass: 'col-6',
			leftColClass: 'col-18',
			componentBreakpoint: ScrollableHoldingsTableBreakPointME,
			replaceZeroWithDash: true
		}
	}
};
